import { Action } from '@ngrx/store';

export class StocksExploreMarketAction implements Action {

    public static getTrends = '[Stocks Explore Market] getTrends';
    public static getTrendsError = '[Stocks Explore Market] getTrendsError';
    public static getMostTrendSuccess = '[Stocks Explore Market] getMostTrendSuccessSuccess';
    public static getIsUpTrendSuccess = '[Stocks Explore Market] getIsUpTrendSuccessSuccess';
    public static getCanUpTrendSuccess = '[Stocks Explore Market] getCanUpTrendSuccessSuccess';
    public static getIsLowTrendSuccess = '[Stocks Explore Market] getIsLowTrendSuccessSuccess';
    public static getCanDownTrendSuccess = '[Stocks Explore Market] getCanDownTrendSuccessSuccess';

    public static searchStock = '[Stocks Explore Market] search_stock';
    public static searchStockError = '[Stocks Explore Market] search_stock_error';
    public static cleanSearchStock = '[Stocks Explore Market] clean_search_stock';
    public static searchStockSuccess = '[Stocks Explore Market] search_stock_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
